
import 'picturefill'; 
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import 'waypoints/lib/noframework.waypoints.min';
import 'lazysizes';
import SmoothScroll from 'smooth-scroll';


import { isNode } from './helpers'

class ProjectsLoader {

	constructor(  ) {

        this.isInitialized = false;

        // This object gets saved to sessionStorage for reuse
        this.state = {
            loadedItems: [],
            everythingIsLoaded: false,
            loadMoreUrl: null,
        }

        // This array saves built items and registers them when loading is done
        this.builtItems = []

        this.baseUrl = '/api/v1/projects.json';
        this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        this.siteIntroductionElement = document.querySelector('.site-introduction');
		this.frontPageIntroduction = document.querySelector('.company-introduction');
        this.projectsOverlay = document.querySelector('.projects-overlay__content');
		this.projectsList = document.querySelector('.projects-list__wrapper');
		this.projectsFooter = document.querySelector('.projects-list__footer');
        this.projectsLoadMoreButton = document.querySelector('.projects-list__footer button');
        this.siteIntroductionElement = document.querySelector('.site-introduction');

	}

    doSiteIntroduction() {

		if ( !document.body.classList.contains('site-introduction-is-visible') ) {
			return
		}

		const scrollContainer = document.querySelector('.scrolling-logo ul')
		const names = document.querySelectorAll('.scrolling-logo li')
		const itemHeight = names[0].offsetHeight

		let x = 0.23
		if ( itemHeight < 51 ) {
			x = 0.8
		} else if ( itemHeight < 101 ) {
			x = 0.6
		} else if ( itemHeight < 151 ) {
			x = 0.3
		}

		const scrollLength = (names.length-2)*itemHeight
		const scrollSpeed = ((x*scrollLength)/100).toFixed(1)

        
        // Check scroll position and destroy logoscroll intro
        // if the user has scrolled past one screen height
		const scrollChecker = () => {

			if ( window.pageYOffset > this.siteIntroductionElement.offsetHeight ) {

				this.siteIntroductionElement.parentNode.removeChild(this.siteIntroductionElement)
				document.body.classList.add('site-introduction-is-removed')
				document.body.classList.remove('site-introduction-is-visible')

				sessionStorage.setItem('removeSplash', true)
                window.scrollTo(0, 0)

				window.removeEventListener('scroll', scrollChecker, false)
                
                this.registerBuiltItems();
                this.registerEvents()

			}

        } 
		window.addEventListener('scroll', scrollChecker, false)

		// On animation finished
		const onTransitionEnd = () => {

			// TimeOut after animation before scrolling
			setTimeout(() => {
				const scroll = new SmoothScroll()
				scroll.animateScroll(this.siteIntroductionElement.offsetHeight+1, null, { 
                    speed: 1500, 
                    easing: 'easeOutCubic',
                });
			}, 1000)

			// Remove event listener
			scrollContainer.removeEventListener('transitionend', onTransitionEnd)
        }

		// Waits before starting logoscroll animation
		setTimeout(() => {
			
			// Start animation
			scrollContainer.style.transform = `translate3d(0,-${scrollLength}px,0)`
			scrollContainer.style.transition = `transform ${scrollSpeed}s cubic-bezier(.4,0,.6,1)`

			// Add event to pick up end of animation
			scrollContainer.addEventListener('transitionend', onTransitionEnd)

		}, 250)




	}

    // Creates a new item node and populates it
	buildItem( item ) {

        if ( !item.image ) {
            return null
        }

        let node = document.createElement("article")
        node.classList.add('projects-list__item')

        let link = document.createElement('a')
        link.classList.add('projects-list__image')
        link.setAttribute('style', `padding-top: ${((Math.floor(item.image.height)/Math.floor(item.image.width))*100).toFixed(2)}%;`)
        link.href = item.url
        link.dataset.title = item.title
        link.dataset.shortDescription = item.shortDescription

        let image = document.createElement('img')
        image.classList.add('lazyload')
        image.sizes = '50vw'
        image.alt = item.image.title
        image.src = item.placeholderImage.src
        image.dataset.srcset = item.image.srcset

        link.appendChild(image)
        node.appendChild(link)

        setTimeout(() => {
            node.classList.add('projects-list__item--visible');
        }, 100);
        

        return node

    }

    clearProjectsOverlay() {

		if ( !this.projectsOverlay ) {
			return;
		}
		this.projectsOverlay.classList.remove('show-overlay');

    }
    
    enableProjectsOverlay( node ) {

        const that = this;

        const link = node.children[0];

        link.addEventListener('mouseenter', e => {

            if ( this.viewportWidth < 1024 ) {
                return;
            }

            const data = e.target.dataset;
            this.populateProjectsOverlay(data.title, data.shortDescription);
            if ( window.pageYOffset <= 5 ) {
                this.frontPageIntroduction.classList.add('hidden');
            }

        })
        link.addEventListener('mouseleave', e => {

            if ( this.viewportWidth < 1024 ) {
                return;
            }

            this.clearProjectsOverlay();
            if ( window.pageYOffset <= 5 ) {
                this.frontPageIntroduction.classList.remove('hidden');
            }
        })

        setTimeout(() => {

            const topWaypoint = new Waypoint({
                element: node,
                handler: function(direction) {
                    
                    if ( that.viewportWidth >= 1024 ) {
                        return;
                    }

                    const data = this.element.children[0].dataset;

                    if ( direction === 'down' ) {
                        this.element.classList.add('projects-list__item--active')
                        that.populateProjectsOverlay(data.title, data.shortDescription);
                    }
                    if ( direction === 'up' ) {
                        this.element.classList.remove('projects-list__item--active')
                        that.clearProjectsOverlay();
                    }

                },
                offset: '45%'
            })

            const bottomWaypoint = new Waypoint({
                element: node,
                handler: function(direction) {
                    
                    if ( that.viewportWidth >= 1024 ) {
                        return;
                    }

                    const data = this.element.children[0].dataset;
                    if ( direction === 'up' ) {
                        this.element.classList.add('projects-list__item--active')
                        that.populateProjectsOverlay(data.title, data.shortDescription);
                    }
                    if ( direction === 'down' ) {
                        this.element.classList.remove('projects-list__item--active')
                        that.clearProjectsOverlay();
                    }
                    

                },
                offset: function () {
                    return (this.context.innerHeight()/2) - this.element.offsetHeight;
                }
            })
        
        }, 150)

	}
    
    populateProjectsOverlay( title, excerpt = null ) {

		if ( !this.projectsOverlay ) {
			return;
		}

		let delay = 10;
		if ( this.projectsOverlay.classList.contains('show-overlay') ) {
			this.projectsOverlay.classList.remove('show-overlay');
			delay = 250;
		}

		setTimeout(() => {

			this.projectsOverlay.innerHTML = '';
			let html = `<h2>${title}</h2>`;
			if ( excerpt ) {
				html += `<p>${excerpt}</p>`;
			}
			this.projectsOverlay.innerHTML = html;
			this.projectsOverlay.classList.add('show-overlay');

		}, delay);

    }
    
    registerBuiltItems() {
        this.builtItems.forEach(item => {
            this.enableProjectsOverlay( item );
        })
    }

    registerEvents() {

        // Load more projects button
        if ( this.projectsLoadMoreButton ) {

			this.projectsLoadMoreButton.addEventListener('click', e => {
                e.preventDefault();
                this.projectsLoadMoreButton.setAttribute('disabled', 'disabled')
				this.projectsFooter.classList.add('projects-list__footer--is-loading');

				setTimeout(() => {
					this.fetchNewProjects( this.state.loadMoreUrl, true );
				}, 500);
			});

        }
        
        // Clears overlay on resize
        window.addEventListener('resize', e => {
			this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
			this.clearProjectsOverlay();
        });
        
        let setPrevScroll,
			prevScrollPosition = window.pageYOffset;

		const setNewScrollPosition = function() {
			prevScrollPosition = window.pageYOffset;
		}

		
		window.addEventListener('scroll', e => {

            // Hide frontPage intro text when the user starts scrolling
            const fullHeight = this.siteIntroductionElement ? this.siteIntroductionElement.offsetHeight : window.innerHeight+5
            const introductionOffset = document.body.classList.contains('site-introduction-is-visible') ? fullHeight : 5

            if ( this.frontPageIntroduction && window.pageYOffset > introductionOffset ) {
                this.frontPageIntroduction.classList.add('hidden');
			} else if ( this.frontPageIntroduction && window.pageYOffset < introductionOffset ) {
                this.frontPageIntroduction.classList.remove('hidden');
                this.clearProjectsOverlay()
            }

            // Hide project overlay on scroll if on large up resolutions
			if ( this.viewportWidth < 1024 ) {
				return;
			}

			clearTimeout(setPrevScroll);
			setPrevScroll = setTimeout(setNewScrollPosition, 100);

			let diff = 0;
			if ( window.pageYOffset > prevScrollPosition ) {
				diff = window.pageYOffset-prevScrollPosition;
			} else if ( window.pageYOffset < prevScrollPosition ) {
				diff = prevScrollPosition-window.pageYOffset;
			}

			if ( diff > 300 ) {
				this.clearProjectsOverlay();
			}

		})

    }

	fetchNewProjects( url, registerNodes ) {

		// Set up our HTTP request
        var xhr = new XMLHttpRequest();

		// Setup our listener to process completed requests
		xhr.onload = () => {

			// Process our return data
			if (xhr.status >= 200 && xhr.status < 300) {
				
				const response = JSON.parse(xhr.response)

                response.data.forEach(item => {
                    
                    // Saves data to state
                    this.state.loadedItems.push( item );
                    
                    // Builds item and saves it to builtItems array after append to the DOM
                    let node = this.buildItem( item )

                    console.log( isNode( node ) );

                    if ( isNode( node ) ) {

                        this.projectsList.appendChild( node )
                        this.builtItems.push(node)

                        // Enables overlay for this node if the load more button is clicked
                        if ( registerNodes ) {
                            this.enableProjectsOverlay( node )
                        }

                    }

                    

                })

                // Set the correct footer state
                this.projectsFooter.classList.remove('projects-list__footer--is-loading');
				this.projectsLoadMoreButton.removeAttribute('disabled');

				if ( this.projectsLoadMoreButton && response.meta.pagination.links.next ) {
                    this.projectsFooter.classList.add('projects-list__footer--visible')
                    this.state.loadMoreUrl = response.meta.pagination.links.next
				} else {
                    this.projectsFooter.classList.remove('projects-list__footer--visible')
                    this.state.everythingIsLoaded = true
                    this.state.loadMoreUrl = null
                }
                
                // Save data in sessionStorage
                window.sessionStorage.setItem( 'projectsList', JSON.stringify( this.state ) )

			} else {
				// What do when the request fails
				console.log('The request failed!');
			}

			// Code that should run regardless of the request status
			// console.log('This always runs...');

		};

		// Create and send a GET request
		// The first argument is the post type (GET, POST, PUT, DELETE, etc.)
		// The second argument is the endpoint URL
		xhr.open('GET', url);
		xhr.send();

    }

    getInitialProjects() {

        // Check for locally stored projects
        const state =  window.sessionStorage.getItem('projectsList')

        if ( state ) {
            
            // Use stored data if available
            this.state = JSON.parse(state)
            this.state.loadedItems.forEach(item => {
                let node = this.buildItem( item )

                if ( isNode( node ) ) {
                    this.projectsList.appendChild( node )
                    this.builtItems.push( node )
                }
                
            })
            if ( this.state.loadMoreUrl && !this.state.everythingIsLoaded ) {
                this.projectsFooter.classList.add('projects-list__footer--visible')
            }

        } else {

            // Fetch new data
            this.fetchNewProjects( this.baseUrl, false );

        }

    }

	init() {

		if ( !this.projectsList ) {
			return;
        }


        const removeSplash = sessionStorage.getItem('removeSplash')

        this.getInitialProjects()

		if ( removeSplash && this.siteIntroductionElement ) {
			this.siteIntroductionElement.parentNode.removeChild(this.siteIntroductionElement)
            document.body.classList.remove('site-introduction-is-visible')
            
            this.registerBuiltItems();
            this.registerEvents()

		} else {
            
            setTimeout(() => {
                this.doSiteIntroduction();	
            }, 500)
            
		}


	}

}

export default ProjectsLoader
